module.exports = __webpack_public_path__ + "static/media/web-apps.69d9fb10.png";